<bottomsheet-layout (dismiss)="closeBottomSheet()">
  <div class="tw-px-2">
    <div class="tw-flex tw-justify-center">
      <div class="tw-w-fit tw-relative">
        <img [src]="productImage" class="tw-w-30 tw-h-[150px] tw-object-contain tw-rounded-3" alt="product" />
        <div class="tw-absolute tw-top-[10px] tw-right-0 tw-translate-x-1/2 tw-translate-y-0">
          <img class="tw-w-[37px] tw-h-[37px]" src="/assets/images/exclamation_orange_inverted.png" alt="exclamation" />
        </div>
      </div>
    </div>
    <p class="tw-text-center tw-font-lexend tw-font-bold tw-text-700 tw-leading-[25px] tw-mt-4 tw-mb-2.5 tw-capitalize" i18n="@@needsDoctorApproval">Needs Doctor Approval</p>
    <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center">
      <span i18n="@@needsDoctorApprovalMessage">{{data.product.title}} needs a doctor's prescription. We'll send your order for doctor review, and it may be cancelled if it's not suitable for you. </span>
    </p>
  </div>

  <div class="tw-mt-8">
    @if (data.navigateToArticlePage) {
      <button csButton
            (click)='closeBottomSheet()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@OkClose">Ok, Close</span>
      </button>
      <button csButton="muted"
              (click)='navigateToArticle()'
              class="tw-w-full tw-text-500 tw-font-semibold tw-capitalize tw-max-w-full"
              style="margin: 0 !important;">
        <span i18n="@@viewProduct">view product</span>
      </button>
    } @else {
      <button csButton
            (click)='addToCart()'
            class="tw-w-full tw-text-500 tw-font-semibold tw-max-w-full"
            style="margin: 0 !important;">
        <span i18n="@@okAddToCart">Ok, Add to cart</span>
      </button>
    }
  </div>
</bottomsheet-layout>
